// postMessage("") 括号一定要带"";

export function _FlutterShowReturn(to, from) {
  if (window._FlutterShowReturn) {
    let showReturnPageName = ['login', 'login-agreement', 'login-privacy']
    if (showReturnPageName.includes(to.name)) {
      window._FlutterShowReturn.postMessage('1')
    } else {
      window._FlutterShowReturn.postMessage('0')
    }
  }
}

//扫描二维码
export function _FlutterScanQrCode(fn) {
  window.getScanQrCode = function(res) {
    fn && fn(res)
  }
  window._FlutterScanQrCode && window._FlutterScanQrCode.postMessage('')
}

// 调用flutter登录方法
export function _FlutterLogin() {
  if (window._FlutterLogin) {
    window._FlutterLogin.postMessage('')
  }
}

// 调用flutter app升级
export function appUpgrade() {
  if (window._FlutterAppUpgrade) {
    window._FlutterAppUpgrade.postMessage('')
  }
}

export function _FlutterPreViewPDF(data) {
  window._FlutterPreViewPDF.postMessage(data)
}

//检测是否有动态心电数据未提交
export function _FlutterEcgDynamicMonitor(fn) {
  if (window._FlutterEcgDynamicMonitor) {
    window.getDynamicMonitorStatus = function(res) {
      fn && fn(res)
    }
    window._FlutterEcgDynamicMonitor.postMessage('')
  }
}

//检测是否有动态心电数据未提交
export function _FlutterGetCamera(fn) {
  if (window._FlutterGetCamera) {
    window.FlutterCamera = function(res) {
      fn && fn(res)
    }
    window._FlutterGetCamera.postMessage('')
  }
}

//跳动态心电提交页面
export function _FlutterJumpDynamicMonitor(type) {
  window._FlutterJumpDynamicMonitor && window._FlutterJumpDynamicMonitor.postMessage(type)
}

// 跳京东小程序
export function _FlutterLinkWeChatMiniProgram() {
  window._FlutterLinkWeChatMiniProgram && window._FlutterLinkWeChatMiniProgram.postMessage('JDHealth')
}
// 粒恩立即测量
export function _JavascriptGoLienEcgMeasure(data) {
  console.log(data, '_JavascriptGoLienEcgMeasure传递的参数')
  window._JavascriptGoLienEcgMeasure && window._JavascriptGoLienEcgMeasure.postMessage(data)
}
// 粒恩绑定
export function _JavascriptBindLienEcgDevice(data) {
  console.log(data, '_JavascriptBindLienEcgDevice传递的参数')
  window._JavascriptBindLienEcgDevice && window._JavascriptBindLienEcgDevice.postMessage(data)
}
// 粒恩外部详情
export function _JavascriptViewLienEcgReport(data) {
  console.log(data, '_JavascriptViewLienEcgReport传递的参数')
  window._JavascriptViewLienEcgReport && window._JavascriptViewLienEcgReport.postMessage(data)
}
